import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warehouse-alt",
  "use": "icon-warehouse-alt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-warehouse-alt\"><path d=\"M24,9.723v11.777c0,1.381-1.119,2.5-2.5,2.5h0c-1.381,0-2.5-1.119-2.5-2.5V12c0-.552-.448-1-1-1H6c-.552,0-1,.448-1,1v9.5c0,1.381-1.119,2.5-2.5,2.5h0c-1.381,0-2.5-1.119-2.5-2.5V9.723c0-1.662,.826-3.215,2.203-4.144L9.203,.855c1.69-1.141,3.904-1.141,5.594,0l7,4.724c1.377,.93,2.203,2.483,2.203,4.144Zm-14,10.277h-1c-.553,0-1,.448-1,1v2c0,.552,.447,1,1,1h1c.553,0,1-.448,1-1v-2c0-.552-.447-1-1-1Zm0-6h-1c-.553,0-1,.448-1,1v2c0,.552,.447,1,1,1h1c.553,0,1-.448,1-1v-2c0-.552-.447-1-1-1Zm5,6h-1c-.553,0-1,.448-1,1v2c0,.552,.447,1,1,1h1c.553,0,1-.448,1-1v-2c0-.552-.447-1-1-1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warehouse-alt.svg
// module id = 0sfK
// module chunks = 63